import {
  ApolloLink,
  FetchResult,
  Observable,
  Operation,
} from "@apollo/client/core";
import { print } from "graphql";
import { Client, ClientOptions, NetworkError, createClient } from "graphql-sse";

import { authorizationHeaders } from "../../utils/graphqlHelper";
import { apiEndpoint } from "../config";

export class SSELink extends ApolloLink {
  private readonly client: Client;
  private readonly getToken: () => string | null;

  constructor(options: ClientOptions, getToken: () => string | null) {
    super();
    this.client = createClient(options);
    this.getToken = getToken;
  }

  public request(operation: Operation): Observable<FetchResult> {
    return new Observable((sink) => {
      return this.client.subscribe<FetchResult>(
        { ...operation, query: print(operation.query) },
        {
          next: (value) => sink.next(value as FetchResult),
          complete: sink.complete.bind(sink),
          error: (err) => {
            try {
              const error = err as NetworkError;
              if (error.response && error.response.status === 401) {
                // Update the context with the new token
                operation.setContext({
                  headers: {
                    ...operation.getContext().headers,
                    Authorization: `Bearer ${this.getToken()}`,
                  },
                });

                // Retry the request
                this.client.subscribe(
                  { ...operation, query: print(operation.query) },
                  {
                    next: sink.next.bind(sink),
                    complete: sink.complete.bind(sink),
                    error: sink.error.bind(sink),
                  },
                );
              } else {
                // If it's not a 401 error, pass it along
                sink.error(err);
              }
            } catch {
              // If it's not a ServerError, pass it along
              sink.error(err);
            }
          },
        },
      );
    });
  }
}

export const createSseLink = (token: string | null) => {
  const headers = authorizationHeaders(token);

  return new SSELink(
    {
      url: apiEndpoint,
      headers,
      retryAttempts: 3,
    },
    () => token,
  );
};
